import { Component, EventEmitter, Output } from '@angular/core';
import { LOCAL_STORAGE_KEY_FILTER_DEFAULT_REALM } from '../const';
import { ACCOUNT_FILTER_DEFAULT_REALM } from '../../game';

@Component({
  selector: 'app-realm-selector-dialog',
  imports: [],
  templateUrl: './realm-selector-dialog.component.html',
  styleUrls: ['../common/dialogs.scss', './realm-selector-dialog.component.scss']
})
export class RealmSelectorDialogComponent {
  @Output() close = new EventEmitter<string>();

  selectedRealm = localStorage.getItem(LOCAL_STORAGE_KEY_FILTER_DEFAULT_REALM) || ACCOUNT_FILTER_DEFAULT_REALM;

  selectRealm(realm: string) {
    this.selectedRealm = realm;
    localStorage.setItem(LOCAL_STORAGE_KEY_FILTER_DEFAULT_REALM, realm);
  }

  closeDialog() {
    localStorage.setItem(LOCAL_STORAGE_KEY_FILTER_DEFAULT_REALM, this.selectedRealm);
    this.close.emit(this.selectedRealm);
  }
}
